import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// Modules
import config from './config.module'
import layout from './layout.module'
import auth from './auth.module'
import profile from './profile.module'
import shippingCollection from './shippingCollection.module'

const store = new Vuex.Store({
  modules: {
    config,
    layout,
    auth,
    profile,
    shippingCollection
  }
})

export default store
